import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from '@phosphor-icons/react';

const formatDate = (value) =>
  value
    ? new Date(value).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
    : null;

export const StoryCard = ({ post, featured = false }) => {
  const date = formatDate(post.published_at || post.created_at);

  if (featured) {
    return (
      <Link
        to={`/news/${post.slug}`}
        className="group block rounded-3xl overflow-hidden bg-white border border-black/[0.05] hover:border-primary/20 hover:shadow-xl transition-all duration-300"
        data-testid={`featured-story-${post.slug}`}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="aspect-[16/10] lg:aspect-auto lg:h-full overflow-hidden bg-slate-100">
            {post.cover_image && (
              <img
                src={post.cover_image}
                alt={post.title}
                className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
              />
            )}
          </div>
          <div className="p-7 md:p-10 flex flex-col justify-center">
            <div className="flex items-center gap-3 mb-4">
              <span className="px-3 h-[26px] inline-flex items-center rounded-full text-[12px] font-medium bg-primary/10 text-primary">
                {post.category_label || post.category}
              </span>
              {date && (
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-muted">
                  <Calendar size={13} /> {date}
                </span>
              )}
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold tracking-tight mb-3 group-hover:text-primary transition-colors">
              {post.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-muted leading-relaxed line-clamp-3">
              {post.excerpt}
            </p>
            <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-primary">
              Read story
              <ArrowRight size={15} weight="bold" className="transition-transform duration-300 group-hover:translate-x-1" />
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${post.slug}`}
      className="group flex flex-col h-full rounded-3xl overflow-hidden bg-white border border-black/[0.05] hover:border-primary/20 hover:shadow-lg transition-all duration-300"
      data-testid={`story-card-${post.slug}`}
    >
      <div className="aspect-[16/10] overflow-hidden bg-slate-100">
        {post.cover_image && (
          <img
            src={post.cover_image}
            alt={post.title}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-500"
          />
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center gap-3 mb-3">
          <span className="px-2.5 h-[24px] inline-flex items-center rounded-full text-[11px] font-medium bg-primary/10 text-primary">
            {post.category_label || post.category}
          </span>
          {date && <span className="text-xs text-foreground-muted">{date}</span>}
        </div>
        <h3 className="text-lg font-semibold leading-snug mb-2 group-hover:text-primary transition-colors line-clamp-2">
          {post.title}
        </h3>
        <p className="text-sm text-foreground-muted line-clamp-3">{post.excerpt}</p>
        <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-primary">
          Read
          <ArrowRight size={14} weight="bold" className="transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
};
